import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { Image } from '../../../models';
import { LabelRoleSize, LinkType } from '../../../types/common.types';

@Component({
  selector: 'idp-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LinkComponent {
  @ViewChild('idpLink') idpLink!: ElementRef;
  @Input() image: Image = {
    src: '',
    show: false,
    alt: ''
  };

  @Input() id = '';
  @Input() index: string | null = '';
  @Input() label = '';
  @Input() role: LinkType = 'primary';
  @Input() ariaHidden = true;
  @Input() ariaPopup = false;
  @Input() labelSize: LabelRoleSize = 'medium';
  @Input() axTitle = 'opens in a new popup';
  @Input() axLabel = '';
  @Input() actionUrl = '';
  @Input() arrow = false;
  @Input() focusBackground = '';
  @Input() defaultRole = 'link';
  @Output() clicked: EventEmitter<boolean> = new EventEmitter();

  notify() {
    this.clicked.emit(true);
  }

  /** Generates the classes that will be used by the component */
  getClasses(): string {
    let classes = `link-${this.role} link__size-${this.labelSize}`;
    if (this.focusBackground === 'transparent') {
      classes = classes + ' link-transparent';
    }
    return classes;
  }
}
